
import listings from './listings'
import listingsResults from './listings.results'
import listingsPagination from './listings.pagination'
import st from './scrollTo'

const self = {


  updateActiveFilterArray : (elementType, type, value, action) => {
    switch (action) {
      case 'deselect' :
        if (elementType == 'checkbox') { // multiples allowed(type === 'neighbourhood') {
          console.log(listings.activeFilters, type, value);
          const index = listings.activeFilters[type].indexOf(value)
          listings.activeFilters[type].splice(index, 1)
        } else {
          delete listings.activeFilters[type]
        }
      break;
      default :
        if (elementType == 'checkbox') { //(type === 'neighbourhood') {
          if (!listings.activeFilters[type]) listings.activeFilters[type] = []
          listings.activeFilters[type].push(value)
        } else {
          listings.activeFilters[type] = value
        }
    }

	  //console.log('updateActiveFilterArray:',elementType, type,value,action, listings.activeFilters);
    // Need to search different fields but in the same list, so if one is present, remove the other one
    //if ( type === 'dwelling_type' && listings.activeFilters.home_style ) delete listings.activeFilters.home_style
    //if ( type === 'home_style' && listings.activeFilters.dwelling_type ) delete listings.activeFilters.dwelling_type

    self.shouldSaveSearchButtonBeDisabled()

    console.log( `updateActiveFilterArray`, listings.activeFilters )
  },


  filterVisibilityToggle : target => {
    const button = (target.nodeName === "I") ? target.parentNode : target
    const containerIsCollapsed = listings.container.classList.contains(listings.collapsedClass)

    if (containerIsCollapsed) {
      self.toggleFilterCollapse('remove')
    } else {
      self.toggleFilterCollapse('add')
    }
  },


  changeTabs : e => {

    // Clicking on the toggle button
    if ( e.target.getAttribute("rel") === 'toggle' || e.target.nodeName === "I" ) {
      self.filterVisibilityToggle(e.target)
      return false
    }

    // Only register events on the buttons
    if ( e.target.nodeName !== "BUTTON" ) return false

    const el = e.target;
    const rel = el.getAttribute("rel")
    const activeButton = listings.elms.pickerTabsNav.querySelector('button.active')
    const activeTab = listings.elms.pickerTabsContainer.querySelector('.tab.active')
    const activeTabRel = (activeTab) ? activeTab.getAttribute('rel') : ''
    const selectedTab = listings.elms.pickerTabsContainer.querySelector(`.tab[rel="${rel}"]`)

    if (
      activeTabRel === 'quick-search' && rel === 'custom-search' ||
      rel === 'quick-search' && activeTabRel === 'custom-search'
    ) {
      // Quick search options are recipes for custom search, when switching between the two tabs we don't clear the active filters or UI
    } else {
      // If switching between custom search, focus search and/or buildings, reset the filter options and clear the active filters
      listings.activeFilters = {}
      self.resetFocusSearch()
      self.resetCustomSearch()
      self.resetBuildingSearch()
    }

    // Manage Nav State
    if (activeButton) activeButton.classList.remove("active")
    el.classList.add("active")

    // Manage Tab State
    if (activeTab) activeTab.classList.remove("active")
    selectedTab.classList.add("active")

    // Open the container if it's collapsed and you change a tab
    const containerIsCollapsed = listings.container.classList.contains(listings.collapsedClass)
    if (containerIsCollapsed) self.toggleFilterCollapse('remove')

    console.log( `changeTabs`, listings.activeFilters )
  },


  quickSearch : e => {
    const button = e.currentTarget
    const parent = button.parentNode.parentNode.querySelector('.title')

    // Reset the custom search form
    self.resetCustomSearch()

    // Store the filter properties from the button
    const buttonFilter = {
      type : button.getAttribute('data-type'),
      value : button.getAttribute('data-val')
    }

    // Store the filter properties from the parent
    const parentFilter = {
      type : parent.getAttribute('data-type'),
      value : parent.getAttribute('data-val')
    }

    // Set the active filters object
    listings.activeFilters[buttonFilter.type] = buttonFilter.value
    listings.activeFilters[parentFilter.type] = parentFilter.value

    // Select the custom search form elements
    let buttonQuerySelector
    if ( buttonFilter.type === 'dwelling_type' || buttonFilter.type === 'home_style' ) {
      buttonQuerySelector = `li[data-type="${buttonFilter.type}"][data-val="${buttonFilter.value}"]`
    } else {
      buttonQuerySelector = `ul[data-type="${buttonFilter.type}"] li[data-val="${buttonFilter.value}"]`
    }
    listings.elms.customSearchTab.querySelector(buttonQuerySelector).classList.add("selected")

    //
    const parentQuerySelector = `ul[data-type="${parentFilter.type}"] li[data-val="${parentFilter.value}"]`
    const activeParentQuerySelector = `ul[data-type="${parentFilter.type}"] li.selected`

    if (listings.elms.customSearchTab.querySelector(activeParentQuerySelector)) {
      listings.elms.customSearchTab.querySelector(activeParentQuerySelector).classList.remove("selected")
    }
    listings.elms.customSearchTab.querySelector(parentQuerySelector).classList.add("selected")

    // Update the UI
    self.shouldSaveSearchButtonBeDisabled()
    listings.elms.btnFilterResults.click()
    st.animate(window.innerHeight * 0.90, 500)
  },


  shouldSaveSearchButtonBeDisabled : () => {
    if (!listings.userID) return false

    if (Object.keys(listings.activeFilters).length === 0) {
      listings.elms.btnSaveSearch.map( btn => btn.disabled = true)
    } else {
      listings.elms.btnSaveSearch.map( btn => btn.disabled = false)
    }
  },


  buildingSearch : e => {
    const button = e.currentTarget
    const address = button.getAttribute('data-address')

    listings.activeFilters = {}
    self.updateActiveFilterArray('text', 'address', [address], 'select')
    st.animate(window.innerHeight * 0.90, 500)
    return listingsResults.updateResults()
  },


  mlsNumberSearch : e => {
    const parent = e.currentTarget.parentNode
    const inputs = [...parent.querySelectorAll('input')]
    const mlsNumberArray = inputs.filter( input => input.value.length > 0 )
    const type = 'mls_number'
    const value = mlsNumberArray.map( input => input.value)
    const action = 'select'

    listings.activeFilters = {}
    self.updateActiveFilterArray('text', type, value, action)
    st.animate(window.innerHeight * 0.90, 500)
    return listingsResults.updateResults()
  },


  addressSearch : e => {
    const parent = e.currentTarget.parentNode
    const inputs = [...parent.querySelectorAll('input')]
    const addressArray = inputs.filter( input => input.value.length > 0 )
    const type = 'address'
    const value = addressArray.map( input => input.value)
    const action = 'select'

    listings.activeFilters = {}
    self.updateActiveFilterArray('text', type, value, action)
    st.animate(window.innerHeight * 0.90, 500)
    return listingsResults.updateResults()
  },


  updateFilterFromRadio : e => {
    const option = e.currentTarget
    const value = option.getAttribute("data-val")
    const type = option.parentNode.getAttribute("data-type") || option.getAttribute("data-type")
    const action = (option.classList.contains("selected")) ? 'deselect' : 'select'

    if (type === 'disabled') return false

    self.toggleRadioBtns(option)

    return self.updateActiveFilterArray('radio', type, value, action)
  },


  updateFilterFromCheckbox : e => {
    const option = e.currentTarget
    const value = option.getAttribute("data-val")
    const type = option.parentNode.getAttribute("data-type") || option.getAttribute("data-type")
    const action = (option.classList.contains("selected")) ? 'deselect' : 'select'

    if (type === 'disabled') return false

    self.toggleCheckboxBtns(option)

    return self.updateActiveFilterArray('checkbox', type, value, action)
  },


  updateFilterFromMinMax : e => {
    const parent    = e.currentTarget.parentNode.parentNode
    const selectMin = parent.querySelector('select[name="min"]')
    const selectMax = parent.querySelector('select[name="max"]')
    const type      = selectMin.getAttribute("data-type")
    const minValue  = selectMin.options[selectMin.selectedIndex].value
    let   maxValue  = selectMax.options[selectMax.selectedIndex].value
          maxValue  = (maxValue === 'any') ? null : maxValue

    // If you choose a min number greater than a max number, reset the max filter
    if ( maxValue && parseInt(minValue) >= parseInt(maxValue) ) {
      selectMax.options[0].selected = true
      maxValue = null
      return
    }

    // Store the range in an object
    const range = {
      min : minValue,
      max : maxValue
    }

    return self.updateActiveFilterArray('number', type, range)
  },


  toggleRadioBtns : option => {
    const type = option.parentNode.getAttribute('data-type')
    const activeOption = option.parentNode.querySelector('.selected')

    // You can select multiple hoods, so only deselect when clicking a selected
    if ( type === 'neighbourhood' ) {
      if ( option.classList.contains('selected') ) {
        option.classList.remove("selected")
      } else {
        option.classList.add("selected")
      }

    // Otherwise only able to select one option at a time
    } else {
      if (activeOption) activeOption.classList.remove("selected")
      if (activeOption !== option) option.classList.add("selected")
    }
  },


  toggleCheckboxBtns : option => {
    const type = option.parentNode.getAttribute('data-type')
    const activeOption = option.parentNode.querySelector('.selected')
	  if ( option.classList.contains('selected') ) {
	    option.classList.remove("selected")
	  } else {
	    option.classList.add("selected")
	  }
  },


  removeLoadingState : () => setTimeout( () => {
    listings.container.classList.remove("loading")
    listings.map.container.parentNode.classList.remove('loading-markers')
  }, 200),


  toggleFilterCollapse : a => {
    const activeTab = listings.elms.pickerTabsContainer.querySelector('.tab.active')
    const filterToggleButton = listings.elms.pickerTabsNav.querySelector('button[rel="toggle"]')

    if (!activeTab) return false

    const contentHeight = activeTab.clientHeight

    listings.elms.pickerTabsContainer.style.height = `${contentHeight}px`

    if (a === "add") filterToggleButton.classList.remove("highlight")
    if (a === "remove") filterToggleButton.classList.add("highlight")

    setTimeout(() => listings.container.classList[a](listings.collapsedClass), 10)
    setTimeout(() => listings.elms.pickerTabsContainer.removeAttribute("style"), 510)
  },


  setTotalListingsDisplay : () => {
    const countContainer = listings.elms.totalListings.querySelector('.total-listings__count')

    countContainer.innerText = listings.totalActiveListings

    if ( listings.elms.totalListings.classList.contains('loading') ) listings.elms.totalListings.classList.remove('loading')
  },

  toggleAllHoods : e => {
    const button = e.currentTarget
    const attr = 'data-show'
    const column = listings.elms.customSearchTab.querySelector(`[${attr}]`)
    const showValue = column.getAttribute(attr)
    const newValue = (showValue === 'misc') ? 'hood' : 'misc'
    const newLabel = (showValue === 'misc') ? 'Show Less' : 'Show All'

    column.setAttribute(attr, newValue)
    button.innerText = newLabel
  },


  getMarkersFromDB : () => {
    const host = (location.hostname == 'dev.jasonhutchison.ca' ? 'www.jasonhutchison.ca' : location.hostname);
    const port = 3010
    const endpoint = 'markers'
    const url = `http://${host}:${port}/${endpoint}`

    console.log('getMarkersFromDB', host)

    return fetch(url, {
      method : 'get',
      mode : 'cors',
      headers : {
        'content-type': 'application/json',
        'Access-Control-Allow-Origin' : '*'
      }
    })
  },

  getResultsFromDB : () => {
    //console.log( listingsPagination.currentPage, listingsPagination.perPage )

    const query = self.getQueryParams()
    const pageParams = `page=${listingsPagination.currentPage}&perPage=${listingsPagination.perPage}`
    const host = (location.hostname == 'dev.jasonhutchison.ca' ? 'www.jasonhutchison.ca' : location.hostname);
    const port = 3010
    const endpoint = 'listings'
    const re = /\+/g
    const url = `http://${host}:${port}/${endpoint}${query}${pageParams}`.replace(re, '%2B')
    console.log('getResultsFromDB', query, host, url)

    return fetch(url, {
      method : 'get',
      mode : 'cors',
      headers : {
        'content-type': 'application/json',
        'Access-Control-Allow-Origin' : '*'
      }
    })
  },

  getQueryParams : () => {
    let query = '?'

    for (let key in listings.activeFilters) {
      if (!listings.activeFilters.hasOwnProperty(key)) return false;
      const value = listings.activeFilters[key]

      if (key === 'price') {
        if (value.min) query += `price_min=${value.min}&`
        if (value.max) query += `price_max=${value.max}&`
      } else {
        query += `${key}=${value}&`
      }
    }

    return query
  },

  setMarkerVisibility : () => {
    for (let marker of listings.markers) {
      const visibleArr = listings.activeMarkerIds.filter( item => item.id === marker.postId )

      if ( visibleArr.length > 0 ) {
        marker.setVisible(true)
      } else {
        marker.setVisible(false)
      }
    }

    listings.map.infowindow.close()
    listings.map.markerCluster.repaint()
  },

  reset : e => {
	  console.log('Reset? ', e);
      self.resetCustomSearch()
  },

  resetCustomSearch : e => {
    const radios = [...listings.elms.customSearchRadios]
    const selects = [...listings.elms.customSearchMinMax]
    const checks = [...listings.elms.customSearchCheckboxes]

    radios.map( radio => radio.classList.remove('selected' ) )

    selects.map( select => select.options[0].selected = 'selected' )
    checks.map( checkbox => checkbox.classList.remove('selected'))

    listings.activeFilters = {}

    if (e) listings.elms.btnFilterResults.click()
  },

  resetFocusSearch : () => {
    const mlsNumberInputs = [...document.querySelectorAll('.tab[rel="focus-search"] .mls-numbers input')]
    const addressInputs = [...document.querySelectorAll('.tab[rel="focus-search"] .address input')]

    mlsNumberInputs.map( input => input.value = '' )
    addressInputs.map( input => input.value = '' )
  },

  resetBuildingSearch : () => {
    // Currently no UI to reset for buildings
  }

}

export default self
